export function UnitConfig (ctx) {
  return {
    header: `<i class="fa fa-file-text-o"></i> <span>unit</span> converters`,
    groups: [
      {
        title: 'Convert to',
        links: [
          { nameTranslated: ctx.$t('length'), name: 'Length', value: '/unit/length-converter' },
          { nameTranslated: ctx.$t('weight'), name: 'Weight', value: '/unit/weight-converter' },
          { nameTranslated: ctx.$t('temperature'), name: 'Temperature', value: '/unit/temperature-converter' },
          { nameTranslated: ctx.$t('energy'), name: 'Energy', value: '/unit/energy-converter' },
          { nameTranslated: ctx.$t('area'), name: 'Area', value: '/unit/area-converter' },
          { nameTranslated: ctx.$t('frequency'), name: 'Frequency', value: '/unit/frequency-converter' },
          { nameTranslated: ctx.$t('power'), name: 'Power', value: '/unit/power-converter' },
          { nameTranslated: ctx.$t('electric'), name: 'Electric', value: '/unit/electric-converter' },
          { nameTranslated: ctx.$t('charge'), name: 'Charge', value: '/unit/charge-converter' },
          { nameTranslated: ctx.$t('voltage'), name: 'Voltage', value: '/unit/voltage-converter' },
        ]
      }
    ]
  }
}
